// extracted by mini-css-extract-plugin
module.exports = {"taboola":"styles_taboola__2M9_D"};